import { SignUp } from "@clerk/clerk-react";
import logo from "src/assets/img/logo.svg";
import loginImg from "src/assets/img/login-background.webp";
import laptopMockup from "src/assets/img/contract-vault-laptop.webp";

// Clerk-powered sign-up. Keeps the original Cognito-era visual shell —
// full-bleed dark background, black/85 overlay, frosted-glass left
// panel with EIQ logo + Contract Vault laptop mockup + hero text —
// and replaces the old 300-line hook-form/OTP/terms scaffold with
// Clerk's <SignUp> component on the right. Account-code gating
// (EQUALIQ2025) is now enforced via Clerk's allowlist in the dashboard,
// not in app code.
const Signup = () => {
  return (
    <main>
      <div className="login-page">
        <section className="min-h-screen flex">
          {/* Full-bleed background with dark overlay */}
          <div
            className="fixed inset-0 bg-cover bg-center bg-no-repeat z-[-1] h-full"
            style={{ backgroundImage: `url(${loginImg})`, backgroundSize: "cover" }}
          >
            <div className="absolute inset-0 z-[1] bg-black/85" />
          </div>

          {/* Left side — hidden on mobile/tablet. Frosted-glass panel
              with logo + laptop mockup + hero text. */}
          <div className="hidden lg:grid flex-[50%] place-items-center px-16 py-16">
            <div className="w-full h-full bg-white/5 rounded-[40px] p-12 overflow-hidden backdrop-blur-lg flex flex-col">
              <div className="mb-8">
                <img src={logo} alt="EIQ" className="w-16" />
              </div>
              <div className="flex-1 w-full flex justify-center items-center">
                <img
                  className="w-full max-w-4xl ml-[calc(50%)]"
                  src={laptopMockup}
                  alt="Contract Vault Dashboard"
                />
              </div>
              <div className="space-y-6 mt-8">
                <h1 className="text-xl font-bold text-white leading-tight">
                  Your AI Deal Orchestrator
                </h1>
                <p className="text-md text-white/80 leading-relaxed max-w-lg">
                  Work with your team to evaluate, sign, and track deals with
                  AI-powered clarity. From negotiation to payments,
                  orchestrate everything in one secure platform.
                </p>
              </div>
            </div>
          </div>

          {/* Right side — Clerk's <SignUp> mounts here. */}
          <div className="w-full lg:flex-[50%] px-4 py-6 sm:px-8 lg:px-16 grid place-items-center">
            <div className="w-full max-w-md">
              <SignUp
                path="/auth/register"
                routing="path"
                signInUrl="/auth/login"
                afterSignInUrl="/organizations"
                afterSignUpUrl="/organizations"
              />
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Signup;
